'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MdRepeatOne = function MdRepeatOne(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm21.6 25h-2.5v-6.6h-2.5v-1.8l3.4-1.6h1.6v10z m6.8 3.4v-6.8h3.2v10h-20v5l-6.6-6.6 6.6-6.6v5h16.8z m-16.8-16.8v6.8h-3.2v-10h20v-5l6.6 6.6-6.6 6.6v-5h-16.8z' })
        )
    );
};

exports.default = MdRepeatOne;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/md/repeat-one.js
// module id = 1386
// module chunks = 36573943044255 79611799117203 213534597649335